import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import AuctionDetail from "@/pages/AuctionDetail";
import CreateAuction from "@/pages/CreateAuction";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import UserProfile from "@/pages/UserProfile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Verify from "@/pages/Verify";
import StoreProfile from "@/pages/StoreProfile";
import StoreSetup from "@/pages/StoreSetup";
import Admin from "@/pages/Admin";
import { BlogList, BlogPost } from "@/pages/Blog";
import { Terms, Privacy, Kvkk } from "@/pages/LegalPages";
import MobileBottomNav from "@/components/MobileBottomNav";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kesfet" element={<Explore />} />
          <Route path="/kesfet/sehir/:city" element={<Explore />} />
          <Route path="/kesfet/:category" element={<Explore />} />
          <Route path="/kesfet/:category/alt/:subcategory" element={<Explore />} />
          <Route path="/kesfet/:city/:category" element={<Explore />} />
          <Route path="/mezat/:id" element={<AuctionDetail />} />
          <Route path="/ilan-ver" element={<CreateAuction />} />
          <Route path="/giris" element={<Login />} />
          <Route path="/kayit" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/panelim" element={<Dashboard />} />
          <Route path="/dogrula" element={<Verify />} />
          <Route path="/magaza/:slug" element={<StoreProfile />} />
          <Route path="/magazam/ayarlar" element={<StoreSetup />} />
          <Route path="/kullanici/:id" element={<UserProfile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/rehber" element={<BlogList />} />
          <Route path="/rehber/:slug" element={<BlogPost />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/kullanim-sartlari" element={<Terms />} />
          <Route path="/gizlilik" element={<Privacy />} />
          <Route path="/kvkk" element={<Kvkk />} />
        </Routes>
      </main>
      <MobileBottomNav />
      {/* Spacer so page content isn't hidden behind mobile nav */}
      <div className="md:hidden h-16" aria-hidden />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <NotificationProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </NotificationProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
